import { UseMutationOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { isBillingAccount } from 'services/is_billing_account';

import { useAPI } from 'hooks/api/useAPI';
import { useMutationWithError } from 'hooks/api/useMutationWithError';
import { useUser } from 'hooks/useAuth';

import { useCurrentOrganization } from './useCurrentOrganization';

export type UseBillingOptions = {
  return_url: string;
};

export type UseBillingResponse = string;

export function useBilling({
  onSuccess,
  ...options
}: UseMutationOptions<UseBillingResponse, APIError, void> = {}) {
  const { client } = useAPI();

  const { data: organization } = useCurrentOrganization();
  const user = useUser();

  return useMutationWithError(
    async () => {
      if (!organization || !isBillingAccount(user, organization.id)) {
        return Promise.reject('Unauthorized.');
      }

      const { data } = await client.post<UseBillingResponse>(
        `/internal/orgs/${organization.id}/stripe_customer_portal`,
        {
          return_url: window.location.href,
        }
      );
      return data;
    },
    {
      ...options,
      entity: 'billing',
      action: 'access',
      onSuccess: (res, ...args) => {
        const portalUrl = res;
        window.location.href = portalUrl;

        if (onSuccess) {
          onSuccess(res, ...args);
        }
      },
    }
  );
}
